import Cookies from 'js-cookie';

import { Cookie } from '../../../network/enums';

export function getFirstNameOfUserFromCookie(): string | undefined {
  const cookieValue = Cookies.get(Cookie.IKEA_SESSION);

  if (!cookieValue) {
    return undefined;
  }

  let firstName: string | undefined;

  try {
    const unescapedDecodedProfileText = atob(cookieValue);
    const decodedProfileText = escape(unescapedDecodedProfileText);
    const profileText = decodeURIComponent(decodedProfileText);
    firstName = JSON.parse(profileText)?.firstName;
  } catch {
    return undefined;
  }

  if (typeof firstName === 'string' && firstName.length > 0) {
    return firstName;
  }

  return undefined;
}
